import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "text-h5"
};
const _hoisted_2 = {
    key: 1,
    class: "text-h5"
};
import { computed, inject, onMounted, reactive, watch, ref } from "vue";
import { Formatter } from "@/util/Formatter";
import { PaymentServiceSymbol } from "@/InjectionSymbols";
import { createOrderPayment, initOrderPayment } from "@/model/OrderPayment";
import { PaymentMethod } from "@/model/enum/PaymentMethod";
import { validationRules } from "@/ValidationRules";
import { useI18n } from "vue-i18n";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderPayments',
    props: {
        orderId: { type: Number, required: false }
    },
    emits: ['paymentUpdated'],
    setup(__props, { emit: __emit }) {
        const { t } = useI18n();
        const paymentService = inject(PaymentServiceSymbol);
        const props = __props;
        const emit = __emit;
        let payments = reactive([]);
        const paymentSum = computed(() => {
            return payments.reduce((previousValue, currentValue) => previousValue + currentValue.amount, 0);
        });
        const headers = [
            { title: 'Datum', key: 'date' },
            { title: 'Betrag', key: 'amount' },
            { title: 'Zahlungsart', key: 'paymentMethod' },
            { title: 'Notiz', key: 'note' },
            { title: '', key: 'actions', sortable: false },
        ];
        const dialog = ref(false);
        const payment = ref(createOrderPayment());
        const deleteDialog = ref(false);
        const paymentToDelete = ref(null);
        const form = ref(null);
        onMounted(() => {
            if (props.orderId) {
                payment.value.orderId = props.orderId;
                loadOrderPayments();
            }
        });
        watch(() => props.orderId, () => {
            loadOrderPayments();
        });
        function onPaymentUpdated() {
            emit('paymentUpdated');
            loadOrderPayments();
        }
        function resetPayment() {
            payment.value = createOrderPayment();
            payment.value.orderId = props.orderId;
        }
        function closeDialog() {
            dialog.value = false;
            resetPayment();
        }
        function savePayment() {
            form.value?.validate().then((result) => {
                if (!result.valid) {
                    return;
                }
                paymentService?.createOrUpdatePayment(payment.value)
                    .then(() => {
                    onPaymentUpdated();
                    closeDialog();
                });
            });
        }
        function editPayment(item) {
            payment.value = initOrderPayment(createOrderPayment(), item);
            dialog.value = true;
            form.value?.resetValidation();
        }
        function requestDelete(item) {
            paymentToDelete.value = item;
            deleteDialog.value = true;
        }
        function confirmDelete() {
            const item = paymentToDelete.value;
            if (!item?.id) {
                deleteDialog.value = false;
                paymentToDelete.value = null;
                return;
            }
            paymentService?.deletePayment(item.id)
                .then(() => {
                onPaymentUpdated();
            }).then(() => {
                deleteDialog.value = false;
                paymentToDelete.value = null;
            });
        }
        function loadOrderPayments() {
            paymentService?.loadPayments(props.orderId)
                .then(response => {
                payments.length = 0;
                for (let entry of response.data) {
                    const payment = initOrderPayment(createOrderPayment(), entry);
                    payments.push(payment);
                }
            });
        }
        return (_ctx, _cache) => {
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_card_title = _resolveComponent("v-card-title");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_vc_date_picker = _resolveComponent("vc-date-picker");
            const _component_v_select = _resolveComponent("v-select");
            const _component_v_textarea = _resolveComponent("v-textarea");
            const _component_v_form = _resolveComponent("v-form");
            const _component_v_card_text = _resolveComponent("v-card-text");
            const _component_v_spacer = _resolveComponent("v-spacer");
            const _component_v_card_actions = _resolveComponent("v-card-actions");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_dialog = _resolveComponent("v-dialog");
            const _component_v_data_table = _resolveComponent("v-data-table");
            const _component_v_card_subtitle = _resolveComponent("v-card-subtitle");
            const _component_v_label = _resolveComponent("v-label");
            return (_openBlock(), _createBlock(_component_v_card, { class: "mt-4" }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_container, { class: "text-start d-flex" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_container, { class: "pa-0 font-weight-bold v-col-6" }, {
                                default: _withCtx(() => _cache[7] || (_cache[7] = [
                                    _createTextVNode("Zahlungseingänge")
                                ])),
                                _: 1
                            }),
                            _createVNode(_component_v_container, { class: "pa-0 font-weight-bold v-col-6 text-end" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(Formatter).currency(paymentSum.value)), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_data_table, {
                        "data-cy": "orderPaymentsTable",
                        class: "text-start",
                        items: _unref(payments),
                        "items-per-page": -1,
                        headers: headers
                    }, {
                        [`header.actions`]: _withCtx(() => [
                            _createVNode(_component_v_dialog, {
                                modelValue: dialog.value,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((dialog).value = $event)),
                                "max-width": "600"
                            }, {
                                activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_container, { class: "d-flex v-col-12 pa-0 ma-0 justify-center" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_btn, _mergeProps(props, { "data-cy": "createOrderPayment" }), {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_icon, { color: "white" }, {
                                                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                                                            _createTextVNode("mdi-plus")
                                                        ])),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 2
                                            }, 1040)
                                        ]),
                                        _: 2
                                    }, 1024)
                                ]),
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card, null, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_card_title, null, {
                                                default: _withCtx(() => [
                                                    (!payment.value.id)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_1, "Neue Zahlung"))
                                                        : (_openBlock(), _createElementBlock("span", _hoisted_2, "Zahlung bearbeiten"))
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_card_text, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_form, {
                                                        ref_key: "form",
                                                        ref: form
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_container, { class: "pa-0 d-flex flex-wrap align-start" }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_v_text_field, {
                                                                        class: "v-col-12 v-col-md-6",
                                                                        label: "Betrag",
                                                                        variant: "outlined",
                                                                        suffix: "€",
                                                                        modelValue: payment.value.amount,
                                                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((payment.value.amount) = $event)),
                                                                        modelModifiers: { number: true },
                                                                        rules: [_unref(validationRules).required, _unref(validationRules).currency],
                                                                        "data-cy": "orderPaymentAmount"
                                                                    }, null, 8, ["modelValue", "rules"]),
                                                                    _createVNode(_component_vc_date_picker, {
                                                                        class: "v-col-12 v-col-md-6",
                                                                        modelValue: payment.value.date,
                                                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((payment.value.date) = $event)),
                                                                        "data-cy": "orderPaymentDate"
                                                                    }, null, 8, ["modelValue"]),
                                                                    _createVNode(_component_v_select, {
                                                                        class: "v-col-12",
                                                                        label: "Zahlungsart",
                                                                        variant: "outlined",
                                                                        items: Object.values(_unref(PaymentMethod)).map(method => ({ value: method, title: _unref(t)(method.toString()) })),
                                                                        modelValue: payment.value.paymentMethod,
                                                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((payment.value.paymentMethod) = $event)),
                                                                        "data-cy": "orderPaymentMethod"
                                                                    }, null, 8, ["items", "modelValue"]),
                                                                    _createVNode(_component_v_textarea, {
                                                                        class: "v-col-12",
                                                                        label: "Notiz",
                                                                        variant: "outlined",
                                                                        rows: "3",
                                                                        modelValue: payment.value.note,
                                                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((payment.value.note) = $event)),
                                                                        rules: [_unref(validationRules).maxLength(1000)],
                                                                        "data-cy": "orderPaymentNote"
                                                                    }, null, 8, ["modelValue", "rules"])
                                                                ]),
                                                                _: 1
                                                            })
                                                        ]),
                                                        _: 1
                                                    }, 512)
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_card_actions, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_spacer),
                                                    _createVNode(_component_v_btn, {
                                                        variant: "text",
                                                        onClick: closeDialog
                                                    }, {
                                                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                                                            _createTextVNode("Abbrechen")
                                                        ])),
                                                        _: 1
                                                    }),
                                                    _createVNode(_component_v_btn, {
                                                        variant: "text",
                                                        onClick: savePayment,
                                                        "data-cy": "saveOrderPayment"
                                                    }, {
                                                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                                                            _createTextVNode("Speichern")
                                                        ])),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }, 8, ["modelValue"])
                        ]),
                        [`item.amount`]: _withCtx(({ item }) => [
                            _createTextVNode(_toDisplayString(_unref(Formatter).currency(item.amount)), 1)
                        ]),
                        [`item.date`]: _withCtx(({ item }) => [
                            _createTextVNode(_toDisplayString(_unref(Formatter).date(item.date)), 1)
                        ]),
                        [`item.paymentMethod`]: _withCtx(({ item }) => [
                            _createTextVNode(_toDisplayString(_unref(t)(item.paymentMethod)), 1)
                        ]),
                        [`item.actions`]: _withCtx(({ item }) => [
                            _createVNode(_component_v_icon, {
                                "data-cy": "editOrderPayment",
                                class: "me-2",
                                color: "info",
                                size: "small",
                                onClick: ($event) => (editPayment(item))
                            }, {
                                default: _withCtx(() => _cache[11] || (_cache[11] = [
                                    _createTextVNode(" mdi-pencil ")
                                ])),
                                _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_v_icon, {
                                "data-cy": "deleteOrderPaymentRequest",
                                color: "error",
                                size: "small",
                                onClick: ($event) => (requestDelete(item))
                            }, {
                                default: _withCtx(() => _cache[12] || (_cache[12] = [
                                    _createTextVNode(" mdi-delete ")
                                ])),
                                _: 2
                            }, 1032, ["onClick"])
                        ]),
                        bottom: _withCtx(({}) => _cache[13] || (_cache[13] = [])),
                        _: 2
                    }, 1032, ["items"]),
                    _createVNode(_component_v_dialog, {
                        modelValue: deleteDialog.value,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((deleteDialog).value = $event)),
                        "max-width": "800px"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "pb-2" }, {
                                        default: _withCtx(() => _cache[14] || (_cache[14] = [
                                            _createElementVNode("span", { class: "text-h5" }, "Zahlung wirklich löschen?", -1)
                                        ])),
                                        _: 1
                                    }),
                                    (paymentToDelete.value)
                                        ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_container, { class: "pa-0 d-flex flex-wrap" }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_container, { class: "v-col-12 v-col-md-4 py-0" }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_v_card_subtitle, { class: "pa-0 text-caption font-weight-medium" }, {
                                                                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                                                                        _createTextVNode("Datum")
                                                                    ])),
                                                                    _: 1
                                                                }),
                                                                _createVNode(_component_v_card_text, { class: "pa-0" }, {
                                                                    default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(_unref(Formatter).date(paymentToDelete.value.date)), 1)
                                                                    ]),
                                                                    _: 1
                                                                })
                                                            ]),
                                                            _: 1
                                                        }),
                                                        _createVNode(_component_v_container, { class: "v-col-12 v-col-md-4 py-0" }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_v_card_subtitle, { class: "pa-0 text-caption font-weight-medium" }, {
                                                                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                                                                        _createTextVNode("Betrag")
                                                                    ])),
                                                                    _: 1
                                                                }),
                                                                _createVNode(_component_v_card_text, { class: "pa-0" }, {
                                                                    default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(_unref(Formatter).currency(paymentToDelete.value.amount)), 1)
                                                                    ]),
                                                                    _: 1
                                                                })
                                                            ]),
                                                            _: 1
                                                        }),
                                                        _createVNode(_component_v_container, { class: "v-col-12 v-col-md-4 py-0" }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_v_card_subtitle, { class: "pa-0 text-caption font-weight-medium" }, {
                                                                    default: _withCtx(() => _cache[17] || (_cache[17] = [
                                                                        _createTextVNode("Typ")
                                                                    ])),
                                                                    _: 1
                                                                }),
                                                                _createVNode(_component_v_card_text, { class: "pa-0" }, {
                                                                    default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(_unref(t)(paymentToDelete.value.paymentMethod)), 1)
                                                                    ]),
                                                                    _: 1
                                                                })
                                                            ]),
                                                            _: 1
                                                        }),
                                                        (paymentToDelete.value.note)
                                                            ? (_openBlock(), _createBlock(_component_v_container, {
                                                                key: 0,
                                                                class: "v-col-12 pt-2"
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_v_label, { class: "text-caption font-weight-medium" }, {
                                                                        default: _withCtx(() => _cache[18] || (_cache[18] = [
                                                                            _createTextVNode("Notiz")
                                                                        ])),
                                                                        _: 1
                                                                    }),
                                                                    _createVNode(_component_v_card, {
                                                                        variant: "tonal",
                                                                        class: "pa-2"
                                                                    }, {
                                                                        default: _withCtx(() => [
                                                                            _createVNode(_component_v_card_text, { class: "pa-0 text-body-2" }, {
                                                                                default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(paymentToDelete.value.note), 1)
                                                                                ]),
                                                                                _: 1
                                                                            })
                                                                        ]),
                                                                        _: 1
                                                                    })
                                                                ]),
                                                                _: 1
                                                            }))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true),
                                    _createVNode(_component_v_card_actions, null, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_spacer),
                                            _createVNode(_component_v_btn, {
                                                class: "mx-2",
                                                variant: "text",
                                                onClick: _cache[5] || (_cache[5] = ($event) => (deleteDialog.value = false))
                                            }, {
                                                default: _withCtx(() => _cache[19] || (_cache[19] = [
                                                    _createTextVNode("Abbrechen")
                                                ])),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_btn, {
                                                class: "mx-2",
                                                color: "error",
                                                variant: "flat",
                                                onClick: confirmDelete,
                                                "data-cy": "confirmDeletePayment"
                                            }, {
                                                default: _withCtx(() => _cache[20] || (_cache[20] = [
                                                    _createTextVNode(" Löschen ")
                                                ])),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }, 8, ["modelValue"])
                ]),
                _: 1
            }));
        };
    }
});
